module.exports = __webpack_public_path__ + "static/img/ipl-logo-orange.2159b60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ipl-logo-orange.svg
// module id = VD/V
// module chunks = 1